(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-faq"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function () {
    $('.answer').hide();
    $('.question-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.answer').slideUp(200);
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-featured-collection-tabs"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
  
  $('.single-collection-tabs-button').click(function(){
    var tab_id = $(this).attr('data-tab-trigger');

    $('.single-collection-tabs-button').removeClass('active');
    $('.single-collection-tab-content').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  })

})
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["component-selecting-supplements"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initSupplementSlider() { 
    $(".single-selecting-supplements.active .js-supplements-carousel").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows:true,
      appendArrows: '.single-selecting-supplements.active .js-supplements-carousel-buttons',
      prevArrow: "<button class='carousel-arrow  previous-arrow'><i class='carousel-arrow-icon'></i></button>",
      nextArrow: "<button class='carousel-arrow next-arrow'><i class='carousel-arrow-icon'></i></button>",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows:true,
            appendArrows: '.single-selecting-supplements.active .js-supplements-carousel-buttons',
          }
        },
        {
          breakpoint: 600,
          centerMode: true,
          centerPadding: '60px',
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true,
            arrows:true,
            appendArrows: '.single-selecting-supplements.active .js-supplements-carousel-buttons',
          }
        }
      ]
    });
  }

  $(document).ready(function(){
    $('.selecting-supplement-buttons button').click(function(){
      var tab_id = $(this).attr('data-tab-trigger');
  
      $('button').removeClass('active');

      $(".single-selecting-supplements.active .js-supplements-carousel").slick('unslick')

      $('.single-selecting-supplements').removeClass('active');
  
      $(this).addClass('active');
      $("#"+tab_id).addClass('active');

      initSupplementSlider()
    })
  })
  
  $(window).on('load', () => {
    initSupplementSlider()
  })
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-nav"]) return;
  try {
    

$(document).ready(function () {

    $('.mob-heading').click(function () {
        $(this).next().slideToggle(200);
      	$(this).toggleClass("expanded");
      
    });
    $('.mobile-child').slideUp(200);
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    

$(document).ready(function(){
  
  $('.single-tab-header').click(function(){
    var tab_id = $(this).attr('data-tab-trigger');

    $('.single-tab-header').removeClass('active');
    $('.single-tab-content').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  })

})
  

$('.js-make-light').click( function() {
  $(this).parents('.product-tabs').addClass('light-bg');
});
$('.js-make-dark').click( function() {
  $(this).parents('.product-tabs').removeClass('light-bg');
});

  } catch(e) { console.error(e); }
})();
})();
